import { render, staticRenderFns } from "./ods-details.vue?vue&type=template&id=2a201f02&scoped=true"
import script from "./ods-details.vue?vue&type=script&lang=js"
export * from "./ods-details.vue?vue&type=script&lang=js"
import style0 from "./ods-details.vue?vue&type=style&index=0&id=2a201f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a201f02",
  null
  
)

export default component.exports